import React from 'react';
import styled from 'styled-components';
import { LogoSpotifyForArtists, VisuallyHidden, white, screenMdMin, screenSmMax } from '@spotify-internal/encore-web';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledLogo = styled(LogoSpotifyForArtists).attrs(function (props) {
  return {
    height: props.condensed ? 28 : 36,
    color: white
  };
}).withConfig({
  displayName: "ResponsiveLogo__StyledLogo",
  componentId: "sc-19yjzhz-0"
})(["@media (max-width:", "){display:", ";}@media (min-width:", "){display:", ";}"], screenSmMax, function (props) {
  return props.condensed ? 'initial' : 'none';
}, screenMdMin, function (props) {
  return props.condensed ? 'none' : 'initial';
});
export var ResponsiveLogo = function ResponsiveLogo() {
  var t = useT();
  var label = t('FRODOR_bfbc75', 'Spotify for Artists', '');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledLogo, {
      "aria-label": label
    }), /*#__PURE__*/_jsx(StyledLogo, {
      condensed: true,
      "aria-label": label
    }), /*#__PURE__*/_jsx(VisuallyHidden, {
      children: label
    })]
  });
};